import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SuspendedPaymentDetailsDTO } from '../../../../../shared/models/data/dto/suspended-payment/suspended-payment-detail.dto';
import { ErrorMessageConstant } from '../../../../../shared/constants/error-message.constants';
import { SuspendedPaymentsData } from '../../../../../modules/payments/data/suspended-payments.data';
import { BsModalRef } from 'ngx-bootstrap';
import { BillingService } from '../../../../../core/services/billing/billing.service';
import { BaseClass } from '../../../../../shared/base-class';
import { SuspendedPaymentsLabel } from '../../../../../shared/constants/suspended-payments.labels.constants';
import { AuthService } from '../../../../../core/services/auth.service';


@Component({
  selector: 'app-payment-confirmation-modal',
  templateUrl: './payment-confirmation-modal.component.html',
  styleUrls: ['./payment-confirmation-modal.component.scss']
})
export class PaymentConfirmationModalComponent extends BaseClass implements OnInit {
  public event: EventEmitter<any> = new EventEmitter();
  message: string;
  actionTypeLabel: string;

  ErrorMessageConstant = ErrorMessageConstant;

  paymentActionForm: FormGroup;

  paymentDetail: SuspendedPaymentDetailsDTO;
  SuspendedPaymentsLabel = SuspendedPaymentsLabel;
  source: string;


  constructor(
    protected fb: FormBuilder,
    public suspendedPaymentsData: SuspendedPaymentsData,
    public bsModalRef: BsModalRef,) {
    super();
  }

  ngOnInit(): void {
    this.paymentActionForm = this.fb.group({
      comment: new FormControl('', [Validators.required])
    });
  }

  confirm(): void {
    if (!this.paymentActionForm.valid) { return; }

    this.triggerEvent({ continue: true, comment: this.paymentActionForm.get('comment').value, source: this.source });
  }

  decline(): void {
    this.triggerEvent({ continue: false });
  }

  triggerEvent(res: any) {
    this.event.emit({ data: res, res: 200 });
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }
}
